<template>
	<!-- Shape of pages/network-index.vue: blue nav bar, "find a church" hero, long-form article. -->
	<div aria-hidden="true">
		<!-- Sub-nav. Mirrors network-subnav.vue: a light bar of pills, not the
		     old full-bleed blue slab — this file hardcodes the bar's colour to
		     avoid a flash, so it has to be updated with it (HAP-4008). -->
		<div class="w-full border-b border-gray-200/80 bg-white/85 dark:border-gray-800 dark:bg-gray-900/70">
			<div class="mx-auto w-full max-w-7xl px-3 md:px-8 flex items-center gap-1 py-2.5">
				<Skeleton v-for="n in 5" :key="n" rounded="rounded-full" class="h-9 w-24 md:w-28 shrink-0" />
			</div>
		</div>

		<!-- Hero -->
		<div class="w-full max-w-5xl mx-auto px-6 py-16 md:py-24 flex flex-col items-center text-center">
			<Skeleton class="h-10 md:h-16 w-3/4 max-w-xl" />
			<Skeleton class="h-10 md:h-16 w-1/2 max-w-md mt-3" />
			<Skeleton rounded="rounded-lg" class="w-full max-w-3xl aspect-[2/1] mt-10" />
		</div>

		<!-- Article -->
		<div class="w-full max-w-3xl mx-auto px-6 pb-24 space-y-3">
			<Skeleton v-for="n in 8" :key="n" class="h-3.5" :class="n % 4 === 0 ? 'w-2/3' : 'w-full'" />
			<div class="flex justify-center gap-4 pt-8">
				<Skeleton rounded="rounded-full" class="h-12 w-44" />
				<Skeleton rounded="rounded-full" class="h-12 w-44" />
			</div>
		</div>
	</div>
</template>

<script>
import Skeleton from '../skeleton.vue'

export default {
	name: 'NetworkSkeleton',
	components: { Skeleton },
}
</script>
